// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"info-icon-2__wrapperThK","wrapper--blue":"info-icon-2__wrapper--blue2mJ"};